import { useMutation, useQueryClient } from "@tanstack/react-query";

import { errorHandler } from "#app/monitoring/errorHandler";
import { showErrorToast } from "#app/notifications";
import { quoteRequestLinesQuery } from "#modules/quoteRequestLines/quoteRequestLinesQuery";
import { quoteRequestQuery } from "#modules/quoteRequests/infra/quoteRequest.query";
import { updateQuoteRequestClient } from "#modules/quoteRequests/infra/updateQuoteRequestClient.api";

type Options = {
  onSuccess?: () => void;
};

export const useUpdateQuoteRequestClient = (options?: Options) => {
  const queryClient = useQueryClient();

  const { mutate, ...rest } = useMutation({
    mutationFn: updateQuoteRequestClient,
    onSuccess: (quoteRequest) => {
      void queryClient.invalidateQueries(quoteRequestQuery(quoteRequest?.id));
      void queryClient.invalidateQueries(quoteRequestLinesQuery());
      options?.onSuccess?.();
    },
    onError: (err) => {
      showErrorToast({
        title: "Une erreur est survenue lors de la mise à jour du client",
      });
      errorHandler(err);
    },
  });

  return { updateQuoteRequestClient: mutate, ...rest };
};
